// Import packages
import React, { Component } from "react";
import { connect } from "react-redux";
import Nestable from "react-nestable";

//import styles


// Import components
import MediaSelectorModal from "../../../components/media/MediaSelectorModal";
import { InputGroup } from "../../../components/uiElements/inputGroup";
import { LinkButton } from "../../../components/buttons/buttons";
import { MediaFileCard } from "../../../components/media/MediaFileCard";

// Import utils
import {
    changeStateField,
    getInputValues, getPatchReqData, getPostReqData,
    getTranslatableInputValues, getTranslationsInitialValues,
    initTranslations, toggleStateField,
} from "../../../utils/helperFunctions";
import { mapStateToProps } from "../../../redux/mapStateToProps";
import {
    GetCafe,
    UpdateCafeById,
} from "../../../redux/actions";
import { validateTranslations } from "../../../utils/validateTranslations";
import { ACCEPT_IMAGE_TYPES } from "../../../constants/acceptedTypes";
import { history } from "../../../configs/history";
import { LanguageTabs } from "../../../components/uiElements/Tabs";
import { MAIN_LANGUAGE_TYPES, MEDIA_MODAL_TYPES } from "../../../constants/constsTypes";
import { transformImage } from "../../../utils/transformImage";


class Cafe extends Component {
    constructor (props) {
        super(props);
        this.translationsFields = [
            'title',
            'description',
            'price_list_object_name',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields),
                image: null,
                logo: null,
                images: [],
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: MAIN_LANGUAGE_TYPES.en,
            requestLoading: false,
            mediaModalOpen: false,
            modalAllowedTypes: '',
            imagesModalOpen: false,
            pdfFileModalOpen: false,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.toggleMediaModal = this.toggleMediaModal.bind(this);
        this.toggleImagesModal = toggleStateField.bind(this, 'imagesModalOpen');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.togglePdfFileModal = toggleStateField.bind(this, 'pdfFileModalOpen');
        this.getPdfFile = this.getPdfFile.bind(this);
        this.getInputValues = getInputValues.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getPostReqData = getPostReqData.bind(this);
        this.onMediaPositionChange = this.onMediaPositionChange.bind(this);
        this.mediaCardWrapper = this.mediaCardWrapper.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.getImagesList = this.getImagesList.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);
        this.addEditCafe = this.addEditCafe.bind(this);
    }

    async componentDidMount () {
        await this.props.GetCafe();
        const editingData = this.props.cafeDate
        if (editingData) {
            const initStateData = {
                translations: getTranslationsInitialValues(editingData.translations, ['title', 'description','price_list_object_name']),
                image: editingData?.image_object_name ?
                    transformImage(editingData.image_object_name, editingData.image_url)
                    : null,
                logo: editingData?.logo_object_name ?
                    transformImage(editingData.logo_object_name, editingData.logo_url)
                    : null,
                images: editingData?.images?.map(item => {
                    return transformImage(item.image_object_name, item.image_url)
                }) || [],
            }
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                fieldsData: initStateData,
            });
        }
    }

    getPdfFile(pdfFile) {
        const {fieldsData,languageTab} = this.state;
        const { translations } = fieldsData;
        this.setState({
            fieldsData: {
                ...fieldsData,
                translations: translations.map(item => item.lang === languageTab ? {
                        ...item,
                        price_list_object_name: pdfFile[0]
                    } : item )
            },
        })
    }
    getImagesList (mediaArray) {
        const { fieldsData, errors } = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                images: mediaArray
            },
            errors: {
                ...errors,
                images: false
            }
        })
    }

    deleteMedia (key, type) {
        const { fieldsData } = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                images: fieldsData.images.filter(item => item.key !== key)
            }
        })
    }

    getMultiSelectData = (checkedKeys, name) => {
        const { fieldsData } = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                [name]: checkedKeys,
            }
        })
    };

    getMedia (mediaArray) {
        const { fieldsData, errors, modalAllowedTypes } = this.state;
        let newState;
        if (modalAllowedTypes === 'image') {
            newState = {
                fieldsData: {
                    ...fieldsData,
                    image: mediaArray[0],
                },
                errors: {
                    ...errors,
                    image: false
                }
            }
        } else if (modalAllowedTypes === 'image_logo') {
            newState = {
                fieldsData: {
                    ...fieldsData,
                    logo: mediaArray[0],
                },
                errors: {
                    ...errors,
                    logo: false
                }
            }
        } else {
            newState = {
                fieldsData: {
                    ...fieldsData,
                    pdf: mediaArray[0],
                },
                errors: {
                    ...errors,
                    pdf: false
                }
            }
        }

        this.setState(newState)
    }

    toggleMediaModal (type='') {
        // console.log('type',type)
        this.setState({
            mediaModalOpen: !this.state.mediaModalOpen,
            modalAllowedTypes: type
        })
    }

    onMediaPositionChange (items) {
        const { fieldsData } = this.state;
        const mediaArray = items.map(item => item.media);
        this.setState({
            fieldsData: {
                ...fieldsData,
                images: mediaArray
            }
        })
    }

    mediaCardWrapper (data) {
        return <MediaFileCard item={data?.item?.media}
                              customDelete={(key) => this.deleteMedia(key, MEDIA_MODAL_TYPES.MEDIA_ARRAY)}/>
    }

    async addEditCafe () {
        await this.setState({
            requestLoading: true
        });
        const { translations, image, pdf, logo } = this.state.fieldsData;
        const translationRequiredFields = ['title', 'description']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = { ...validationTr.errors };

        // if (!images) {
        //     errors.images = true;
        //     result = false;
        // }

        if (!image) {
            errors.image = true;
            result = false;
        }
        if (!logo) {
            errors.logo = true;
            result = false;
        }
        if (result) {
            // const trData = getTranslationData(translations);
            // const reqData = this.getPatchReqData(trData);
            let reqData = this.getPostReqData(this.state.fieldsData);
            if (Object.keys(reqData).length) {
                this.props.UpdateCafeById(reqData)
                    .finally(() => {
                        this.setState({ requestLoading: false });
                    });
            } else {
                await this.setState({ requestLoading: false });
                history.push('/service/cafe')
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }


    render () {
        const {
            fieldsData,
            errors,
            languageTab,
            mediaModalOpen,
            errorsTabs,
            modalAllowedTypes,
            imagesModalOpen,
            pdfFileModalOpen,
        } = this.state;

        let mediaItems = [];

        fieldsData.images.forEach((media, index) => {
            mediaItems.push({
                id: index,
                media: media
            })
        });

        const initData = this.currentData?.translations?.find(item => item?.lang === languageTab) || {};
        const currentData = fieldsData?.translations?.find(item => item?.lang === languageTab) || {};
        return <div>
            <section className="general-add-edit">
                <div className={'tops-wrapper'}>
                    <div className="top-side">
                        <label>Նկար <span className={'required-badge'}>*</span></label>
                        <LinkButton title="Ընտրել մեդիադարանից"
                                    className={`media-select-btn ${errors.image ? 'media-select-error' : ''}`}
                                    cb={this.toggleMediaModal.bind(this, 'image')}
                        />
                        {fieldsData?.image && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.image}
                            />
                        </div>}
                    </div>
                    <div className="top-side">
                        <label>Նկար Կայք<span className={'required-badge'}>*</span></label>
                        <LinkButton title="Ընտրել մեդիադարանից"
                                    className={`media-select-btn ${errors.logo ? 'media-select-error' : ''}`}
                                    cb={this.toggleMediaModal.bind(this, 'image_logo')}
                        />
                        {fieldsData?.logo && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.logo}
                            />
                        </div>}
                    </div>

                </div>
                <div className={'posts-medias-list-wrapper '}>
                    <div className={'label-and-action'}>
                        <label>Նկարներ</label>
                        <LinkButton title="Ընտրել Մեդիադարանից"
                                    className={`media-select-btn`}
                                    cb={this.toggleImagesModal}/>
                    </div>
                    <section className={'items-wrapper items-medias-list-wrapper'}>
                        {fieldsData.images.length ? <Nestable
                                items={mediaItems}
                                maxDepth={1}
                                onChange={this.onMediaPositionChange}
                                renderItem={this.mediaCardWrapper}
                            /> :
                            <p className={'empty-text'}>Նկարներ չկան</p>}
                    </section>
                </div>

                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>

                <div className={'label-and-action'}>
                    <label>Կցել PDF File</label>
                    <LinkButton className={"media-select-btn bg-white"}
                                title={"Ընտրել PDF ֆայլ"}
                                cb={this.togglePdfFileModal}/>
                </div>
                <div className={'contract-wrapper'}>
                    <div className={'wrapper'}>
                        <span>Անվանում՝ {currentData?.price_list_object_name?.name || currentData?.price_list_object_name}</span>
                    </div>
                </div>

                <InputGroup inputType="input"
                            type="text"
                            label="Անվանում"
                            placeholder="Անվանում"
                            name="title"
                            required={true}
                            value={currentData.title}
                            initValue={initData.title}
                            error={errors['title' + languageTab]}
                            maxLength={100}
                            onChange={this.getTranslationValues}/>
                <InputGroup inputType="input"
                            type="text"
                            label="Նկարագրություն"
                            placeholder="Նկարագրություն"
                            name="description"
                            required={true}
                            value={currentData.description}
                            initValue={initData.description}
                            error={errors['description' + languageTab]}
                            maxLength={1000}
                            onChange={this.getTranslationValues}/>

                <div className="flex-wrapper-right">
                    <LinkButton title={'Փոփոխել'}
                                cb={this.addEditCafe}/>
                </div>
            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalOpen}
                acceptTypes={modalAllowedTypes === 'pdf' ? ['pdf'] : ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
            <MediaSelectorModal
                isOpen={!!imagesModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getImagesList}
                multiSelect={true}
                closeModal={this.toggleImagesModal}
            />
            <MediaSelectorModal
                isOpen={!!pdfFileModalOpen}
                acceptTypes={['pdf']}
                getMedia={this.getPdfFile}
                appendMedias={fieldsData.price_list_object_name}
                closeModal={this.togglePdfFileModal}
            />
        </div>
    }
}

const mapDispatchToProps = {
    GetCafe,
    UpdateCafeById,
};

export default connect(mapStateToProps, mapDispatchToProps)(Cafe)
